// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { LabelPackageInfoMessage } from '@tls/sw91-communication/types/com.api_db_access';
import { createContext } from 'react';
import { QCResult } from '../data/filter/filters-defaults';

export type EditImageProps = {
  imageMd5?: string;
  hasMask?: boolean;
  imageName?: string;
  previewData?: Uint8Array;
  isValidation?: boolean;
  updateTime?: Date;
};

export interface ImagesContextType {
  images: LabelPackageInfoMessage[];
  addImage: (message: LabelPackageInfoMessage) => void;
  removeImage: (imageMd5: string) => void;
  editImage: (props: EditImageProps) => void;
  loading: boolean;
  updateMaskMetadata: (imageMd5: string, isValidation: boolean, qcResult: QCResult) => void;
  updateImageTags: (imageMd5: string, labels: string[]) => void;
}

export const ImagesContext = createContext<ImagesContextType>({
  images: [],
  addImage: function noRef() {},
  removeImage: function noRef() {},
  editImage: function noRef() {},
  loading: false,
  updateMaskMetadata: function noRef() {},
  updateImageTags: function noRef() {},
});
